// extracted by mini-css-extract-plugin
module.exports = {"Report-card-box":"cj","reportCardBox":"cj","report-img-wrap":"ck","reportImgWrap":"ck","report-title":"cl","reportTitle":"cl","report-date":"cm","reportDate":"cm"};